'use client';

import {ErrorSection} from '@/app/_components/shared/error-section';
import {useLocale} from '@/app/_contexts/locale-context';
import {errorLabels, type ErrorLabelLocale} from '@/app/_lib/error-labels.generated';

export default function NotFound() {
    const locale = useLocale();

    // Labels come from a frozen TYPO3 snapshot (error-labels.generated.ts), not
    // the live API or a client cache — so this page renders localized text even
    // when the backend is down. Locale is derived from the URL, never the API.
    // locale comes from the URL and can be anything — check membership for real
    // instead of a lying cast that types the lookup as always-defined.
    const globalLabels = Object.hasOwn(errorLabels, locale)
      ? errorLabels[locale as ErrorLabelLocale]
      : errorLabels.de;

    const title = globalLabels['404Tagline'] || 'Page Not Found';
    const tagline = globalLabels['404Title'] || '404';
    const description = globalLabels['404Description'] || "The page you're looking for doesn't exist or has been moved. Please check the URL or navigate back home.";
    const defaultButtonLabel = globalLabels.homeButtonLabel || 'Go to homepage';
    const homeHref = locale !== 'de' ? `/${locale}` : '/';

    return (
        <ErrorSection
            tagline={tagline}
            title={title}
            description={description}
            defaultButtonLabel={defaultButtonLabel}
            homeHref={homeHref}
            showResetButton={false}
        />
    );
}
